/* eslint-disable react/jsx-props-no-spreading */
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Autocomplete,
} from "@mui/material";
import {
  COMPARISON_OPTIONS,
  comparisonIdToString,
  comparisonStringToId,
} from "./comparison-types";

interface ReplacementValueFormDialogProps {
  open: boolean;
  formValues: {
    value: string;
    newValue: string;
    comparisonTypeId: number;
  };
  editIndex: number | null;
  isSaving: boolean;
  onClose: () => void;
  onSave: () => void;
  onChange: (values: {
    value: string;
    newValue: string;
    comparisonTypeId: number;
  }) => void;
}

const ReplacementValueFormDialog = ({
  open,
  formValues,
  editIndex,
  isSaving,
  onClose,
  onSave,
  onChange,
}: ReplacementValueFormDialogProps) => {
  const isFormValid = formValues.value.trim() && formValues.newValue.trim();

  // Convert comparisonTypeId to string for display
  const comparisonString =
    formValues.comparisonTypeId > 0
      ? comparisonIdToString(formValues.comparisonTypeId)
      : "";

  const handleComparisonChange = (newValue: string | null) => {
    const comparisonTypeId = newValue ? comparisonStringToId(newValue) : 0;
    onChange({ ...formValues, comparisonTypeId });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {editIndex === null
          ? "Add Replacement Value"
          : "Edit Replacement Value"}
      </DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Value"
          fullWidth
          value={formValues.value}
          onChange={(e) => onChange({ ...formValues, value: e.target.value })}
          placeholder="e.g., Male"
          helperText="Original value to replace"
          sx={{ mb: 2 }}
          disabled={isSaving}
        />
        <TextField
          margin="dense"
          label="New Value"
          fullWidth
          value={formValues.newValue}
          onChange={(e) =>
            onChange({ ...formValues, newValue: e.target.value })
          }
          placeholder="e.g., M"
          helperText="Replacement value"
          sx={{ mb: 2 }}
          disabled={isSaving}
        />
        <Autocomplete
          options={[...COMPARISON_OPTIONS]}
          value={comparisonString || null}
          onChange={(_e, newValue) => handleComparisonChange(newValue)}
          renderInput={(params) => (
            <TextField
              {...params}
              margin="dense"
              label="Comparison"
              placeholder="Select Comparison"
              helperText="Comparison type (optional)"
              onKeyDown={(e) => {
                if (e.key === "Enter" && isFormValid) {
                  onSave();
                }
              }}
            />
          )}
          fullWidth
          disabled={isSaving}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit" disabled={isSaving}>
          Cancel
        </Button>
        <Button
          onClick={onSave}
          variant="contained"
          disabled={!isFormValid || isSaving}
        >
          {editIndex === null ? "Add" : "Update"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReplacementValueFormDialog;
